module.exports = __webpack_public_path__ + "img/logo.7cf9d5f9.png";